// Could be united with ApiStatus
export const networkStatus = {
  CLEAR: "CLEAR",
  SUCCESS: "SUCCESS",
  IN_PROGRESS: "IN_PROGRESS",
  ERROR_UNAUTH: "ERROR_UNAUTH",
  ERROR_OTHER: "ERROR_OTHER",
};
